// extracted by mini-css-extract-plugin
export default {"bgObject":"BackgroundObject_bgObject__r40Ay","breathe":"BackgroundObject_breathe__E9wt0"};